import api from '@/api/api';
import StringUtils from "@/utils/string.utils";

const ENDPOINT = 'user';

class UserService {

    getUsers(page, rows, filter) {
        const body = this.buildRequestBody(page, rows, filter);
        return api().post(`/${ENDPOINT}`, body);
    }

    getSupervisors(page, rows, filter) {
        const body = this.buildRequestBody(page, rows, filter);
        return api().post(`/${ENDPOINT}/supervisor`, body);
    }

    getBranches() {
        return api().get(`/${ENDPOINT}/branch`);
    }

    getProfiles() {
        return api().get(`/${ENDPOINT}/profile`);
    }

    toggleStatus(userId) {
        return api().put(`/${ENDPOINT}/${userId}/status`);
    }

    changeProfile(userId, profile) {
        return api().put(`/${ENDPOINT}/${userId}/profile`, {profile});
    }

    buildRequestBody(page, rows, filter) {
        const body = {
            page: page,
            size: rows,
            sortField: filter.sortField,
            sortOrder: filter.sortOrder,
        }

        if (!StringUtils.isBlank(filter.name)) {
            body['name'] = filter.name.trim();
        }

        if (!StringUtils.isBlank(filter.email)) {
            body['email'] = filter.email.trim();
        }

        if (filter.profile) {
            body['profile'] = filter.profile
        }

        if (filter.branches?.length > 0) {
            body['branches'] = filter.branches;
        }
        return body;
    }

    getTeachersSupervisor(userId) {
        return api().get(`/${ENDPOINT}/supervisor/${userId}/teacher`);
    }

    getTeachersPicklist() {
        return api().get(`/${ENDPOINT}/teacher/picklist`);
    }

    saveSupervisorsTeachers(userId, teachersIds) {
        return api().put(`/${ENDPOINT}/supervisor/${userId}/teacher`, {teachersIds});
    }
}

export default new UserService();